/**
 * RteContent
 * @module components/RteContent
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import nextConfig from 'common/config';
import style from './RteContent.scss';
import templateStyle from './RteTemplates.scss';
import widgetStyle from './RteWidgets.scss';

/** Class representing the component. */
class RteContent extends Component {

	/**
	 * The render method
	 */
	render () {
		const { content, type, color, router } = this.props;
		let modifiedContent = content;

		// If we are in preview mode (Drupal admin),
		// force links to reload the parent frame instead of only the iframe
		// and replace internal links with admin links.
		if (router.asPath.indexOf('_preview') !== -1) {
			const regex = new RegExp(nextConfig.domain, 'g');
			modifiedContent = modifiedContent.replace(/<a/g, '<a target="_parent"');
			modifiedContent = modifiedContent.replace(regex, nextConfig.adminUrl);
		}

		const classes = type === 'small' ?
			`rteContent small${color ? ` ${color}` : ''}` :
			`rteContent${color ? ` ${color}` : ''}`;

		return <div className={classes} dangerouslySetInnerHTML={{ __html: modifiedContent }} />;
	}
}


/** Prop types **/
RteContent.propTypes = {
	content: PropTypes.string,
	type: PropTypes.oneOf(['small']),
	color: PropTypes.oneOf(['white'])
};


export default withRouter(RteContent);
